<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: 'mall'
}
</script>

<style>
</style>
